var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6992 2.88672C16.5078 2.75 16.2344 2.72266 16.0156 2.85938L3.32812 10.0781C3.10938 10.1875 2.97266 10.4336 3 10.6797C3 10.9258 3.16406 11.1445 3.38281 11.2539L7.59375 13.0039V16.0938C7.59375 16.3398 7.70312 16.5586 7.92188 16.6953C8.03125 16.7227 8.14062 16.75 8.22266 16.75C8.33203 16.75 8.46875 16.7227 8.57812 16.668L11.6133 14.6992L14.293 15.8477C14.375 15.875 14.457 15.9023 14.5664 15.9023C14.6758 15.9023 14.7852 15.8477 14.8672 15.793C15.0586 15.7109 15.168 15.5195 15.1953 15.3281L16.9453 3.51562C17.0273 3.26953 16.918 3.02344 16.6992 2.88672ZM13.0898 6.03125L7.97656 11.7461L5.13281 10.543L13.0898 6.03125ZM8.87891 14.8906V13.5508L10.1367 14.0977L8.87891 14.8906ZM14.0469 14.2891L9.23438 12.2656L15.3594 5.45703L14.0469 14.2891Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.d517969dfa31ad4f48b0499c17385391.svg";
export { ForwardRef as ReactComponent };